export default [
  {
    header: 'navbars.real_estate',
    permission: [
      'content_management',
      'supervisor',
      'manager',
      'super_manager',
    ],
    unique_name: 'my-objects',
  },
  {
    title: 'navbars.object_accounting',
    route: 'my-objects',
    icon: 'CodesandboxIcon',
    permission: [
      'content_management',
      'supervisor',
      'manager',
      'super_manager',
    ],
    unique_name: 'my-objects',
  },
]
